import { LoadingSpinningIcon } from '@assets/icons/LoadingSpinningIcon';
import AnomalyAlertIcon from '@assets/icons/minor/AnomalyAlertIcon';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@components/shadcn/components/ui/tooltip';
import { useUnits } from '@hooks/useUnits';
import { useTranslation } from 'react-i18next';

export const AnomalyInformationTooltip = ({
  isLoadingAnomalyData,
  anomalyData,
}: {
  isLoadingAnomalyData?: boolean;
  anomalyData: { area?: number; quantity?: number };
}) => {
  const { t } = useTranslation();
  const { longTranslationKey, area } = useUnits();
  const iconColor = anomalyData.quantity ? '#0066FF' : '#A3A9B9';
  const displayedData = anomalyData.quantity ? anomalyData.quantity : '--';
  const tooltipText = anomalyData.area
    ? t('header.properties.anomaly_area', {
        area: Math.round(anomalyData.area / area),
        unit: t(longTranslationKey),
      })
    : t('header.properties.anomaly_empty');

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger>
          <div className="flex items-center gap-0.5 min-w-11 bg-white rounded-[28px] px-1 py-px text-right">
            {isLoadingAnomalyData ? <LoadingSpinningIcon /> : <AnomalyAlertIcon fill={iconColor} />}
            <span className="mx-auto">{displayedData}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent
          align="start"
          side="right"
          className="max-w-[170px] z-[1030] bg-sy-anomaly-blue-60 rounded px-2.5 py-1.5"
        >
          <p className="text-sm">
            {isLoadingAnomalyData ? t('header.properties.anomaly_loading') : tooltipText}
          </p>
          <TooltipArrow className="fill-sy-anomaly-blue-60" />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
